import { lazy, Suspense } from 'react'

import type { CodeElementType } from './codeTypes'

// Lazy-load CodeMirror runtime + all @codemirror/lang-* + @lezer/* parsers
// (~400 KB gzip combined). The Code element is rare in courses — when not
// present we never load any of this.
const CodeElementInner = lazy(
  () => import(/* webpackChunkName: "code-mirror" */ './CodeElementInner'),
)

const CodeElement: CodeElementType = (props) => (
  <Suspense fallback={null}>
    <CodeElementInner {...props} />
  </Suspense>
)

export default CodeElement
